// The tabs of the Voice page, kept in ?tab= so the sidebar can link straight to one.
export const VOICE_PAGE_TABS = {
  SETTINGS: 'settings',
  TRANSCRIPTIONS: 'transcriptions',
};
